import Immutable from 'immutable';

export const identity = value => value;

export const createReducer = (initialState, reduceMap) =>
    (state = initialState, action) => {
        if (!action) {
            return state;
        }
        const reduce = reduceMap[action.type];
        if (reduce) {
            return reduce(state, action);
        }
        return state;
    };

export const createImmutableReducer = (initialState, reduceMap) =>
    (state = Immutable.fromJS(initialState), action) => {
        const reduce = reduceMap[action.type];
        if (reduce) {
            return state.withMutations(state => reduce(state, action));
        }
        return state;
    };

export function composeReducer(...fns) {
    return (state, action) => fns.reduce(
        (last, fn) => fn(last, action),
        state,
    );
}

export const createAction = (type, payloadReducer, metaReducer) => {
    function actionCreator(...args) {
        const action = {
            type,
        };
        if (payloadReducer) {
            const payload = payloadReducer(...args);
            if (payload !== undefined) {
                action.payload = payload;
            }
        }
        if (metaReducer) {
            action.meta = metaReducer(...args);
        }
        if (action.payload instanceof Error) {
            action.error = true;
        }
        return action;
    }
    const typeString = type.toString();
    actionCreator.toString = () => typeString;
    actionCreator.type = type;
    return actionCreator;
};
